import React, { Fragment } from "react";

type Props = {
    incentives?: string[];
};

const CartSalesIncentives = ({ incentives = [] }: Props) => {
    return (
        <Fragment>
            {incentives.map((i, index) => {
                return (
                    <section key={index} className="text-success">
                        {i}
                    </section>
                );
            })}
        </Fragment>
    );
};

export default CartSalesIncentives;
